import Model from "./Model";

export interface FromDatabaseRef {
  id: number;
  name: string;
}

export default class SubscriptionRequest extends Model {
  static type = "subscriptionRequests";

  status: string;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: Date;
  fromDatabase?: FromDatabaseRef | null;

  get fullname() {
    return this.firstName + " " + this.lastName;
  }
}

export class CreateSubscriptionRequest {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  fromDatabaseUuid?: string | null;
  gdprAccepted: boolean;

  constructor() {
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.fromDatabaseUuid = null;
    this.gdprAccepted = false;
  }
}
